import { gql } from 'graphql-request'

export const ManyNewsQuery = gql`
  query AllNews(
    $page: Int = 1
    $limit: Int = 50
    $locale: LocaleInputType!
    $now: DateTime!
    $where: News_where_and = {}
    $isPreview: Boolean! = false
    $statuses: [News__status_Input] = [published]
  ) {
    allNews(
      draft: $isPreview
      page: $page
      limit: $limit
      locale: $locale
      sort: "-datePosted"
      where: {
        AND: [
          { _status: { in: $statuses } }
          {
            OR: [
              { visibleUntil: { exists: false } }
              { visibleUntil: { equals: null } }
              { visibleUntil: { greater_than_equal: $now } }
            ]
          }
          $where
        ]
      }
    ) {
      docs {
        id
        title
        slug
        datePosted
      }
      totalDocs
      hasNextPage
    }
  }
`
